export default "__VITE_ASSET__C87ZKZ1t__"